const { isArray, isString } = require('@/functions/is');

/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 */
const OrderResource = function (
    $resource,
    apiRequestParams,
    appConfig,
) {
    return $resource(
        appConfig.apiBaseUrl + 'orders/:id',
        Object.assign(
            apiRequestParams.defaults(),
            {
                branchID: () => apiRequestParams.getAllUserBranchIDs().join(','),
                resolve: () => apiRequestParams.getResolveForOrderRequest().join(','),
            }
        ),
        {
            query: {
                isArray: true,
                method: 'GET',
            },
            queryUnfulfilled: {
                isArray: true,
                method: 'GET',
                url: appConfig.apiBaseUrl + 'orders/unfulfilled',
            },
            queryActiveFulfillments: {
                isArray: true,
                method: 'GET',
                url: appConfig.apiBaseUrl + 'orders/active-fulfillments',
            },
            get: {
                method: 'GET',
                params: {
                    includeBookingTotals: 1,
                },
                transformResponse: (data) => {
                    // As we are overriding the default behaviour of the response processing, we have to do
                    // the work of the default processing. This is, in essence, decoding the JSON string.
                    if (isString(data)) {
                        data = JSON.parse(data);
                    }
                    // As we cannot seem to find the page links, we are making blind requests to the API
                    // for the next page. When we have exhausted the data being sent, the next empty page
                    // returns an empty array. That needs to be mapped to an object for the underlying
                    // logic to work correctly without major reworking.
                    if (isArray(data) && data.length === 0) {
                        data = {};
                    }

                    return data;
                },
            },
            confirm: {
                method: 'POST',
            },
            update: {
                method: 'PUT',
            },
            emailReceipt: {
                method: 'POST',
                url: appConfig.apiBaseUrl + 'orders/:id/sendEmailReceipt',
            },
        }
    );
};

module.exports = OrderResource;
